import { Link } from "react-router-dom";
import { Target, Clock, ArrowRight, Sparkles } from "lucide-react";
import { EISENHOWER_META } from "../lib/eisenhower";
import { formatDate } from "../lib/format";

/**
 * Bug 19/50 · Hero card Home: "Oggi costruisci questo".
 *
 * Riceve `items[]` già filtrati e ordinati (Costruisci → Gestisci → Risolvi,
 * a parità scadenza più vicina prima). Max 3 elementi.
 *
 * Click su item → callback onOpenTask(task) (parent decide se apri modal edit
 * o naviga a /cicli).
 */
export default function TodayBuildCard({ items = [], areasById = {}, onOpenTask }) {
  const list = (items || []).slice(0, 3);

  return (
    <section className="pxos-card p-5 sm:p-6" data-testid="home-today-build">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="rounded-2xl p-2 bg-emerald-50 text-emerald-700">
            <Sparkles size={18}/>
          </span>
          <div>
            <div className="text-[11px] uppercase tracking-widest opacity-70">Focus di oggi</div>
            <h2 className="font-display text-xl font-semibold" data-testid="home-today-build-title">
              Oggi costruisci questo
            </h2>
          </div>
        </div>
        <Link to="/cicli" className="text-xs inline-flex items-center gap-1 opacity-70 hover:opacity-100"
              data-testid="home-today-build-see-all">
          Tutti i cicli <ArrowRight size={12}/>
        </Link>
      </div>

      {list.length === 0 ? (
        <div className="text-sm opacity-70 py-4" data-testid="home-today-build-empty">
          Nessuna azione prioritaria per oggi. Ottima occasione per aprire un nuovo ciclo
          o rivedere le mete.
        </div>
      ) : (
        <ul className="space-y-2">
          {list.map((t) => {
            const eis = t.__eisKey ? EISENHOWER_META[t.__eisKey] : null;
            const area = t.area_id ? areasById[t.area_id] : null;
            const primary = t.scheduled_date || t.due_date;
            const timeLabel = t.scheduled_time ? t.scheduled_time.slice(0, 5) : null;
            return (
              <li key={t.id} data-testid={`home-today-build-item-${t.id}`}>
                <button
                  type="button"
                  onClick={() => onOpenTask?.(t)}
                  className="w-full text-left flex items-start gap-3 py-2.5 px-3 rounded-lg hover:bg-black/[0.03] transition"
                >
                  <span className="mt-0.5 shrink-0 rounded-full p-1.5"
                        style={{ background: (area?.color || "#95BAEF") + "22", color: area?.color || "#3d5a80" }}>
                    <Target size={14}/>
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-medium">{t.title}</span>
                      {eis && (
                        <span className={`text-[10px] font-semibold uppercase tracking-widest px-2 py-0.5 rounded-full ${eis.cls}`}
                              data-testid={`home-today-build-eis-${t.id}`}>
                          {eis.label}
                        </span>
                      )}
                    </div>
                    <div className="text-xs opacity-70 mt-0.5 flex items-center gap-2 flex-wrap">
                      {area && (
                        <span className="inline-flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full" style={{ background: area.color || "#95BAEF" }}/>
                          {area.name}
                        </span>
                      )}
                      {primary && (
                        <span className="inline-flex items-center gap-1">
                          <Clock size={10}/>
                          {formatDate(primary)}
                          {timeLabel ? ` · ${timeLabel}` : ""}
                        </span>
                      )}
                    </div>
                  </div>
                  <ArrowRight size={14} className="opacity-30 shrink-0 mt-1"/>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
